module.exports = __webpack_public_path__ + "img/jobs_i8.da721043.png";